import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import { generateFromString } from 'generate-avatar'

import AvatarInput from '~/client/components/AvatarInput'

export default function AvatarAndNameInputs({
  disabled,
  avatar,
  onAvatarChange,
  name,
  onNameChange,
  autoFocusAvatar = false,
  autoFocusName = false,
  ...props
}){

  return <Stack
    direction="row"
    spacing={2}
    alignItems="center"
    {...props}
  >
    <AvatarInput {...{
      autoFocus: autoFocusAvatar,
      disabled,
      value: avatar || '',
      onChange: onAvatarChange,
      circular: true,
    }}/>
    <TextField
      autoFocus={autoFocusName}
      label="Name"
      autoComplete="name"
      disabled={disabled}
      margin="normal"
      fullWidth
      name="name"
      type="text"
      value={name ?? ''}
      onChange={e => {
        const name = e.target.value
        onNameChange(name)
        if (name && (!avatar || avatar.startsWith(generatedAvatarPrefix)))
          onAvatarChange(`${generatedAvatarPrefix}${generateFromString(name)}`)
      }}
      sx={{flexGrow: 1}}
    />
  </Stack>
}

const generatedAvatarPrefix = `data:image/svg+xml;utf8,`
